import axios from "axios";
import {
  CHARIOT_SUPP_ARTICLE,
  CHARIOT_AJOUT_ARTICLE,
  CHARIOT_AJOUT_REQUETTE,
  CHARIOT_SAVE_METHODE_PAIEMENT,
  CHARIOT_LIVRAISON_ADRESSE,
  CHARIOT_SAVE_DATE_LIVRAISON,
  CHARIOT_RESET,
  CHARIOT_SAVE_VARIABLE_GLOB,
  CHARIOT_TOTALE_PRIX,
} from "../constantes/chariotConstantes";

//const uri = `http://${manifest.debuggerHost.split(":").shift()}:5000`;
//const uri = `https://ecreal.herokuapp.com`;
//const uri = `https://ecreal.onrender.com`;
//const uri = `https://ahmed.prod-manager.tk/back`;
//const uri = `https://gestpro.globalsystempro.com/back`;
import { store } from "../store";
let uri = "";
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();
export const ajoutChariot =
  (article, qty, prixTotal, langue, source, pu, unite, code_art) =>
  async (dispatch, getState) => {
    /*const articles = store.getState().articlesListe.articles;
    console.log(articles);*/
    const {
      articleFamille: { articlesF },
      articleListe: { articles },
      client: { client },
    } = getState();
    let data =
      client.specialise == "N"
        ? articlesF.find((a) => a._id == article)
        : articles.find((a) => a._id == article);

    try {
      /*const { data } = await axios.get(
        `${uri}/api/articles/details/${article}`
      );*/

      // a partir de actiondetail...: const { data } = await Axios.get(`${uri}/api/articles/details/${aId}`);
      dispatch({
        //cet payload a pour but est de sauvgarder les donnée d'un ligne chariot avec des info importer a partir de composant articledetail
        type: CHARIOT_AJOUT_ARTICLE,
        payload: {
          article: data._id,
          nom: data.nom,
          image: data.image,
          prix: pu,
          prix_total: prixTotal,
          num_stock: data.num_stock,
          qty,
          langue,
          source,
          coiff: data?.coiff,
          typ_mvt: unite,
          code_art,
        },
      });
    } catch (error) {
      console.log(error);
    }

    //console.log(getState().chariot.chariotListe)
  };
export const suppChariot = (id) => async (dispatch, getState) => {
  //dispatch directement vers reducer sans passer par la fonction
  dispatch({ type: CHARIOT_SUPP_ARTICLE, payload: id });
};
export const saveAdressePaie =
  (adr, methodePaiement, date_livraison) => async (dispatch, getState) => {
    dispatch({ type: CHARIOT_LIVRAISON_ADRESSE, payload: adr });
    dispatch({ type: CHARIOT_SAVE_METHODE_PAIEMENT, payload: methodePaiement });
    dispatch({ type: CHARIOT_SAVE_DATE_LIVRAISON, payload: date_livraison });
  };
export const saveVariableGlo = (varGlo) => async (dispatch, getState) => {
  dispatch({ type: CHARIOT_SAVE_VARIABLE_GLOB, payload: varGlo });
};
export const saveTotPrix = (totPrix) => async (dispatch, getState) => {
  dispatch({ type: CHARIOT_TOTALE_PRIX, payload: totPrix });
};
export const resetChariot = () => async (dispatch) => {
  await dispatch({ type: CHARIOT_RESET });
};
